import React from 'react';
import { Line, LineChart, ReferenceLine, ResponsiveContainer, YAxis } from 'recharts';

export default function ForensicSparkline({ series = [], median = null, zone = 'neutral' }) {
    const data = (series || [])
        .map((point) => ({
            year: point.year,
            value: point.value == null ? null : Number(point.value),
        }))
        .filter((point) => point.value == null || Number.isFinite(point.value));

    if (!data.some((point) => point.value != null)) {
        return <div className="forensic-sparkline forensic-sparkline--empty" aria-hidden="true" />;
    }

    const stroke =
        zone === 'red' ? 'var(--danger)' :
            zone === 'yellow' ? 'var(--warning)' :
                zone === 'green' ? 'var(--success)' :
                    'var(--brand-2)';

    return (
        <div className="forensic-sparkline" role="img" aria-label="Multi-year trend">
            <ResponsiveContainer width="100%" height={44}>
                <LineChart data={data} margin={{ top: 6, right: 4, bottom: 2, left: 4 }}>
                    <YAxis hide domain={['auto', 'auto']} />
                    {median != null && Number.isFinite(Number(median)) && (
                        <ReferenceLine y={Number(median)} stroke="var(--muted)" strokeDasharray="3 3" />
                    )}
                    <Line
                        type="monotone"
                        dataKey="value"
                        stroke={stroke}
                        strokeWidth={2}
                        dot={false}
                        connectNulls={false}
                        isAnimationActive={false}
                    />
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
}
